import React from "react";
import { KanbanScripts } from "./KanbanScripts";
import IntlMessages from "../../../../util/IntlMessages";

interface SumOfItemsProps {
   settings: any;
   columns: Array<any>;
   column: any;
}

const SumOfItems: React.FC<SumOfItemsProps> = ({ columns, column, settings }) => {
   return (
      <>
         {settings?.sumNumberOfRowsInColumn && (
            <div className="list-kanban-sum">
               <IntlMessages id="kanban.sumOfRowsInColumn" />: {column.items.length}
            </div>
         )}
         {settings.itemContent?.map(({ columns: items }) => {
            return (
               <>
                  {items.map(({ sumColumn, columnTechName }) => {
                     if (sumColumn) {
                        return (
                           <div className="list-kanban-sum">
                              <IntlMessages id="kanban.sumOf" />
                              {" " + KanbanScripts.getTitleFromTechName(columnTechName, columns)}:
                              {" " +
                                 column.items
                                    .reduce(
                                       (oldSum: number, currentValue: object) =>
                                          oldSum +
                                          (parseFloat(
                                             currentValue[
                                                KanbanScripts.getTitleFromTechName(
                                                   columnTechName,
                                                   columns
                                                )
                                             ]
                                          ) || 0),
                                       0
                                    )
                                    .toFixed(2)}
                           </div>
                        );
                     }
                  })}
               </>
            );
         })}
      </>
   );
};

export default SumOfItems;
